/**
 * Life4Earth V2 — Full-Project Status Reports API adapter (DEV-1296 Slice C).
 *
 * Dated TipTap narrative + photos on the Performance → Summary tab. NO KPI
 * coding. Optional Journal/feed posting (Lead/authorized, write/edit-time).
 */

import { apiFetch } from './client';

export interface ProjectStatusReportPhoto {
  photoGuid: string;
  storageKey: string;
  caption?: string | null;
  position: number;
}

export interface ProjectStatusReport {
  statusReportGuid: string;
  projectGuid: string;
  reportingDate: string;
  narrativeHtml: string;
  postedByUserGuid: string;
  postedAt: string;
  photos: ProjectStatusReportPhoto[];
  postedToJournal?: boolean;
  journalHeadline?: string | null;
  postedToFeed?: boolean;
}

export interface ProjectStatusReportSummary {
  statusReportGuid: string;
  reportingDate: string;
  postedByUserGuid: string;
  postedAt: string;
}

export interface ProjectStatusReportPhotoItem {
  storageKey: string;
  caption?: string | null;
  position: number;
}

export interface CreateProjectStatusReportBody {
  reportingDate: string;
  narrativeHtml: string;
  photos?: ProjectStatusReportPhotoItem[];
  postToJournal?: boolean;
  journalHeadline?: string | null;
  postToFeed?: boolean;
  /** DEV-1297: resolved feed-visibility level ('none'|'org'|'public'). */
  feedVisibility?: string;
}

export interface UpdateProjectStatusReportBody {
  narrativeHtml: string;
  photos?: ProjectStatusReportPhotoItem[];
  postToJournal?: boolean;
  journalHeadline?: string | null;
  postToFeed?: boolean;
  /** DEV-1297: resolved feed-visibility level ('none'|'org'|'public'). */
  feedVisibility?: string;
}

export const listProjectStatusReports = (projectGuid: string) =>
  apiFetch<ProjectStatusReportSummary[]>(`/api/projects/${projectGuid}/status-reports`);

export const getProjectStatusReport = (projectGuid: string, guid: string) =>
  apiFetch<ProjectStatusReport>(`/api/projects/${projectGuid}/status-reports/${guid}`);

export const createProjectStatusReport = (
  projectGuid: string,
  body: CreateProjectStatusReportBody,
) =>
  apiFetch<ProjectStatusReport>(`/api/projects/${projectGuid}/status-reports`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateProjectStatusReport = (
  projectGuid: string,
  guid: string,
  body: UpdateProjectStatusReportBody,
) =>
  apiFetch<ProjectStatusReport>(`/api/projects/${projectGuid}/status-reports/${guid}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });

export const deleteProjectStatusReport = (projectGuid: string, guid: string) =>
  apiFetch<void>(`/api/projects/${projectGuid}/status-reports/${guid}`, { method: 'DELETE' });
